// Fractal entry saved in localStorage
export interface StoredFractal {
  name: string;
  data: any;
  image: string;
}

// Read saved fractals from localStorage
export function loadFractals(): StoredFractal[] {
  if(localStorage["fractals"]) {
    return JSON.parse(localStorage["fractals"]);
  } else {
    return [];
  }
}

// Save fractals to localStorage
export function saveFractals(fractals: StoredFractal[]) {
  localStorage["fractals"] = JSON.stringify(fractals);
}